<template>
    <div class="here-1" v-if="!project"
        :data-component-name="$options.name"
    >
        <div class="c-dashboard-row -project-desc" ref="projectWrapper" :id="'project'+newProjectModel.id">
            <div class="c-dashboard__item -project-title">
                <div class="c-project-title__wrap">
                    <div class="c-project-title">
                        <div class="c-project-title__status">
                            <q-icon :class="newProjectModel.status.toLowerCase()" name="new_releases" v-if="newProjectModel.status=='NEWPROJECT'"></q-icon>
                            <span :class="'o-status-pin -'+ newProjectModel.status.toLowerCase()" v-else><!-- STATUS CLASS .-draft,.-hasdraft,.-published,.-alert,.-confirmed,.-completed -->
                            </span>
                            <q-tooltip>
                                <!-- {{ statusStr }} -->
                                Nouveau projet
                            </q-tooltip>
                        </div>
                        <div class="c-project-title__name">
                            {{ newProjectModel.name }}
                            <!-- {{ newProjectModel.name }} (dev id:{{ newProjectModel.id }}) -->
                        </div>
                        <div class="c-project-title__client" v-if="newProjectModel.customers.length>0">
                            {{ newProjectModel.customers.map(a => a.name).join(', ') }}
                        </div>
                        <div class="c-project-title__id" v-if="newProjectModel.contract_number">
                            no. {{ newProjectModel.contract_number }}
                        </div>
                        <div
                            class="c-project-title__no-shift"
                            v-if="newProjectModel.shifts.length==0 && newProjectModel.draftShifts.length==0"
                        >
                            Aucun quart de travail pour la semaine sélectionnée
                        </div>
                    </div>
                    <div class="c-project-title__controls">
                        <button class="c-project-title__controls__item -view">
                            <SvgIcon name="eye" />
                        </button>
                        <button class="c-project-title__controls__item -expand" @click.stop="showProjectDetails = showProjectDetails==false; $refs.projectWrapper.classList.toggle('is-project-expanded');">
                            <SvgIcon name="add" class="-idle" />
                            <SvgIcon name="minus" class="-active" />
                        </button>
                    </div>

                </div>
            </div>
            <div class="c-dashboard-project" v-if="showProjectDetails">
                    <ProjectForm class="c-dashboard-project__inner"
                        @cancel="toggleProjectDetails(false)"
                        @refetch-projects="$emit('new-project', $event)"
                        :project="newProjectModel"
                        v-bind:weekrange="weekrange"
                        :newProject="true"
                        :projectDetailsVisible="projectDetailsVisible"
                    />
                    <!-- <ProjectForm class="c-dashboard-project__inner"
                        @cancel="toggleProjectDetails(false)"
                        @refetch-projects="toggleProjectDetails(false); $emit('cancel', false); $eventBus.$emit('jump-to-project', { projectID: $event.id, currentDate: $event.start_date})"
                        :project="newProjectModel"
                        v-bind:weekrange="weekrange"
                        :newProject="true"
                        :projectDetailsVisible="projectDetailsVisible"
                    /> -->
                    <!-- <ProjectForm class="c-dashboard-project__inner"
                        @cancel="$emit('cancel', newProjectModel)"
                        @refetch-projects="newProjectModel=$event"
                        v-bind:weekrange="weekrange"
                        :newProject="true"
                    /> -->
            </div>

        </div>
        <Shifts
            v-if="newProjectModel.id>0"
            v-bind:currentDate="currentDate"
            v-bind:shiftsView="shiftsView"
            v-bind:weekrange="weekrange"
            v-bind:shifts="newProjectModel.shifts"
            v-bind:draftShifts="newProjectModel.draftShifts"
            v-bind:prevShift="newProjectModel.prevShift"
            v-bind:nextShift="newProjectModel.nextShift"
            @set-current-date="$emit('set-current-date', $event)"
        />
    </div>
    <div v-else>
        <div class="c-dashboard-row -project-desc" ref="projectWrapper" :id="'project'+project.id">
            <div class="c-dashboard__item -control -left">
                <button
                    class="c-dashboard-control -previous-week"
                    @click="$emit('set-current-date', prevWeek)"
                >
                    <SvgIcon name="arrow-alt-left" />
                </button>
            </div>
            <div class="c-dashboard__item -project-title" @click="toggleProjectDetails(showProjectDetails==false); $refs.projectWrapper.classList.toggle('is-project-expanded');"
                :class="{'is-archived': project.status=='ARCHIVED'}"
            >
            <!-- <div class="c-dashboard__item -project-title" @click="showProjectDetails = "> -->
                <div class="c-project-title__wrap">
                    <div class="c-project-title">
                        <div class="c-project-title__status">
                            <q-icon name="archive" v-if="project.status=='ARCHIVED'"></q-icon>
                            <q-icon :class="project.status.toLowerCase()" name="new_releases" v-else-if="project.status=='NEWPROJECT'"></q-icon>
                            <span :class="'o-status-pin -'+ project.status.toLowerCase()" v-else><!-- STATUS CLASS .-draft,.-hasdraft,.-published,.-alert,.-confirmed,.-completed -->
                            </span>
                            <q-tooltip>
                                {{ statusStr }}
                            </q-tooltip>
                        </div>
                        <div class="c-project-title__name">
                            <q-icon name="bookmark"
                                v-if="project.projectCategories.length"
                                :style="'color: ' + project.projectCategories[0].color"
                                size="14px"
                            ></q-icon>
                            {{ project.name }}
                        </div>

                        <div class="c-project-title__client" v-if="project.customers.length>0">
                            -
                        </div>
                        <div class="c-project-title__client" v-if="project.customers.length>0">
                            {{ project.customers.map(a => a.name).join(', ') }}
                        </div>

                        <div class="c-project-title__client" v-if="project.contract_number">
                            -
                        </div>
                        <div class="c-project-title__id" v-if="project.contract_number">
                            no. {{ project.contract_number }}
                        </div>

                        <div class="c-project-title__client" v-if="project.projectManager">
                            -
                        </div>
                        <div class="c-project-title__client" v-if="project.projectManager" title="Chargé de projet">
                            <q-icon class="-icon" name="record_voice_over" />
                            <!-- {{ project.projectManager.name }} -->
                            <UserProfileInfo :userProfile="project.projectManager" :customContent="project.projectManager.name" />
                        </div>

                        <div
                            class="c-project-title__no-shift"
                            v-if="project.shifts.length==0 && project.draftShifts.length==0"
                        >
                            Aucun quart de travail pour la semaine sélectionnée
                        </div>
                    </div>
                    <div class="c-project-title__controls">
                        <!-- <button class="c-project-title__controls__item -view">
                            <SvgIcon name="eye" />
                        </button> -->
                        <ProjectCardToggle class="c-project-title__controls__item -view" :projectID="project.id" :size="'16px'" />
                         <button class="c-project-title__controls__item -expand" @click.stop="showProjectDetails = showProjectDetails==false; $refs.projectWrapper.classList.toggle('is-project-expanded');">
                            <SvgIcon name="add" class="-idle" />
                            <SvgIcon name="minus" class="-active" />
                        </button>
                    </div>
                </div>
            </div>
            <div class="c-dashboard__item -control -right">
                <button
                    class="c-dashboard-control -next-week"
                    @click="$emit('set-current-date', nextWeek)"
                >
                    <SvgIcon name="arrow-alt-right" />
                </button>
            </div>
            <div class="break">
            </div>
            <div class="c-dashboard-project" v-if="showProjectDetails">
                <ProjectForm class="c-dashboard-project__inner"
                    @cancel="toggleProjectDetails(false)"
                    v-bind:project="project"
                    v-bind:weekrange="weekrange"
                    :projectDetailsVisible="projectDetailsVisible"
                    :shiftOverride="shiftOverride"
                    @deleted-projects="$emit('deleted-projects')"
                />
            </div>
        </div><!-- .c-dashboard-row .-project-desc -->
        <Shifts
            v-bind:currentDate="currentDate"
            v-bind:shiftsView="shiftsView"
            v-bind:weekrange="weekrange"
            v-bind:shifts="project.shifts"
            v-bind:draftShifts="project.draftShifts"
            v-bind:prevShift="project.prevShift"
            v-bind:nextShift="project.nextShift"
            @set-current-date="$emit('set-current-date', $event)"
            @create-shift-override="toggleProjectDetails(true);shiftOverride=$event; $emit('create-shift-override', $event)"
        />
    </div>
</template>

<script>
    import ProjectForm from '@/components/forms/ProjectForm'
    import Shifts from '@/components/projects/Shifts'
    import moment from 'moment';
    import {statusStr} from '@/js/utilities'
    import { MYPROFILE } from '@/graphql/user/queries'

    export default {
        name: 'Project',
        components:{
            ProjectForm,
            Shifts
        },
        props: {
            project: {},
            currentDate: String,
            weekrange: {},
            shiftsView: String,
            newProject: {
                type: Boolean,
                default: false,
            },
        },
        data(){
            return{
                showProjectDetails: false,
                projectDetailsVisible: false,
                visibilityTO: {},
                newProjectModel: {
                    id: 0,
                    name: "Nouveau projet",
                    projectStatus: "NEWPROJECT",
                    status: "NEWPROJECT",
                    shifts: [],
                    draftShifts: [],
                    customers: [],
                    customtags: [],
                    projectShifts: []
                },
                shiftOverride: null
            }
        },
        // watch: {
        // },
        computed: {
            statusStr(){
                if(!this.project) return statusStr(0)
                return statusStr(this.project.status)
            },
            prevWeek(){
                return moment(this.currentDate).subtract(7, 'days').format('YYYY-MM-DD');
            },
            nextWeek(){
                return moment(this.currentDate).add(7, 'days').format('YYYY-MM-DD');
            },
        },
        mounted(){
            if(this.newProject){
                this.showProjectDetails=true;
                this.toggleProjectDetails(true)
            }


            this.$eventBus.$on('toggle-project-details', function(e){
                if(e==this.project.id) this.toggleProjectDetails(true)
            }.bind(this))
        },
        beforeDestroy() {
            document.removeEventListener('scroll', this.onScroll);
            this.$eventBus.$off('toggle-project-details');
        },
        methods:{
            toggleProjectDetails(visible){
                this.projectDetailsVisible=visible
                clearTimeout(this.visibilityTO);
                if(!visible){
                    this.visibilityTO=setTimeout(function(){
                        this.showProjectDetails=visible;
                        if(this.newProject) this.$emit('cancel', this.newProjectModel)
                    }.bind(this), 200)
                }else{
                    // this.showProjectDetails=visible;
                    let projectID=0;
                    if(this.project) projectID=this.project.id
                    let offset=-100;
                    let moreFiltersEL=document.querySelector(".js-more-filters-nav");
                    if(moreFiltersEL) offset=offset-moreFiltersEL.offsetHeight;

                    this.$scrollTo(
                        "#project"+projectID,
                        200,
                        {
                            offset: offset,
                            onDone: function(){
                                this.showProjectDetails=visible;
                                this.$scrollTo("#project"+projectID, 200, {offset: offset});
                            }.bind(this)
                        }
                    )
                }
            },
        },
        apollo: {
            myProfile: {
                query: MYPROFILE,
                fetchPolicy: 'cache-only',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(data){
                    this.newProjectModel.projectManager=data.myProfile
                    return data
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .project-details {
        border-bottom: 1px solid black;
        padding: 16px 16px;
        background: white;
    }
    .project-row {
        background: grey;
        color: white;
        padding: 6px 16px;
    }
</style>
